<template>
  <div class="home">
    <QuickRegister />
    <!-- <div class="banner-items">
      <template v-for="(item, index) in banner">
        <BannerItem :data="item" :key="`Baner-${index}`" />
      </template>
    </div>
    <div class="banner-two-wrap" v-if="bannerTwo && bannerTwo.length">
      <template v-for="(item, index) in bannerTwo">
        <BannerItemTwo :data="item" :key="`BanerTwo-${index}`" />
      </template>
    </div>
    <div class="banner-three-wrap" v-if="bannerThree && bannerThree.length">
      <div class="kids-hits">KIDS</div>
      <template v-for="(item, index) in bannerThree">
        <BannerItemThree :data="item" :key="`BanerThree-${index}`" />
      </template>
    </div>
    <div class="banner-news" v-if="news && news.title && news.content">
      <h3>{{news.title}}</h3>
      <div id="autoHigh">
        <template v-for="(item, index) in news.content">
          <HomeNews :data="item" :key="index" />
        </template>
      </div>
      <div class="more-sub" v-on:click="changeFoldState">
        <span>{{brandFold?'收起':'展开'}}</span>
      </div>
    </div>
    <div class="banner-one-wrap" v-if="bannerOne && bannerOne.length">
      <template v-for="(item, index) in bannerOne">
        <BannerItemOne :data="item" :key="`BanerOne-${index}`" />
      </template>
    </div>
    <div class="recommend-wrapper">
      <Recommend />
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import types from "@/store/types";
import api from "@/utils/api";
// import BannerItem from "@/components/BannerItem.vue";
// import BannerItemOne from "@/components/BannerItemOne.vue";
// import BannerItemTwo from "@/components/BannerItemTwo.vue";
// import BannerItemThree from "@/components/BannerItemThree.vue";
// import HomeNews from "@/components/HomeNews.vue";
// import Recommend from "@/components/Recommend.vue";
import QuickRegister from "@/components/QuickRegister.vue";

export default {
  name: "HomePage",
  components: {
    // BannerItem,
    // Recommend,
    // HomeNews,
    // BannerItemOne,
    // BannerItemTwo,
    // BannerItemThree
    QuickRegister,
  },
  data() {
    return {
      banner: [],
      bannerTwo: [],
      bannerThree: [],
      bannerOne: [],
      news: {},
      brandFold: false
    };
  },
  created() {
    // this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.GET_HOME_LIST]()
        .then(res => {
          if (res?.code == 1) {
            this.banner = res?.data?.list || res?.list;
            let { column_4, column_3, column_1, news } = res?.data?.data;
            this.bannerTwo = column_4;
            this.bannerThree = column_3;
            this.bannerOne = column_1;
            this.news = news;
            this.newsList = news;
          } else {
            console.warn(res);
          }
        })
        .catch(err => {
          console.warn(err);
        });
    },
    changeFoldState() {
      if (this.brandFold == false) {
        document.getElementById("autoHigh").style.height = "auto";
        this.brandFold = !this.brandFold;
      } else {
        document.getElementById("autoHigh").style.height = "50px";
        this.brandFold = !this.brandFold;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.banner-items {
  padding: 0 2px;
}

.banner-two-wrap {
  padding: 0 2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.banner-three-wrap {
  padding: 0 2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .kids-hits {
    width: calc(50% - 1px);
    margin: 0 2px 2px 0;
    font-size: 20px;
    color: #000000;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
  }
}

.banner-news {
  text-align: center;
  padding-bottom: 24px;

  h3 {
    color: #222222;
    font-size: 16px;
    font-weight: bold;
    margin: 50px auto 15px;
    text-align: center;
  }

  .more-sub {
    margin-top: 10px;

    span {
      cursor: pointer;
    }
  }
}

.banner-one-wrap {
  margin-top: 0px;
  padding: 0 2px;
}

#autoHigh {
  height: 50px;
  overflow: hidden;
}

@media only screen and (max-width: 640px) {
  .banner-news {
    text-align: left;
    padding: 0 1rem 24px 1rem;
  }

  .banner-two-wrap {
    flex-direction: column;
  }

  .banner-three-wrap {
    flex-wrap: wrap;

    .kids-hits {
      display: flex;
    }
  }
}
</style>
